import { ApPlan } from '../../types/ApPlan';
import { CreateDirectApPlanActionRequest } from '../../types/ApPlanAction';
import { libApiInstance } from '../axios';
import { ChannelItemsRequest } from './types/channelItemsRequest';
import { ChannelItemsResponse } from './types/channelItemsResponse';

export async function requestTimeline(
    contactId: number,
    data: ChannelItemsRequest,
    signal?: AbortSignal,
): Promise<ChannelItemsResponse> {
    const result = await libApiInstance.post(`/contacts/${contactId}/channelsTyped`, data, {
        signal,
    });
    return result.data;
}

export async function requestCreateDirectApPlan(
    data: CreateDirectApPlanActionRequest,
): Promise<ApPlan> {
    const result = await libApiInstance.post<ApPlan>(`/actionplans/createdirectaction`, data);
    console.log('Timeline => ', result);
    return result.data;
}
